<template>

  <ContentsProductHighPerformancePageTitle title="PP (Polypropylene)" />

  <!-- PRODUCT DETAIL PAGE -->
  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/commodity-plastics/fer01.jpg"
            :contents="[
              'PP generally has good impact, toughness, resistance to environmental stress cracking, fatigue resistance, excellent electrical and chemical resistance. Different types of PP exhibit unique properties such as PP homo is good at stiffness, PP Copo is good at impact and PP random is transparent. PP can improve its performance by adding filler known as PP compound for better stiffness, lower shrinkage, better dimensional stability, and chemical resistance.'
            ]"
            is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
          
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/commodity-plastics/pp-1.jpg"
            :contents="[
              'Flexible packaging, film, food tray, rigid packaging, crate, caps, closure, detergent bottles, car bumpers, exterior trim, door module, car interior parts.'
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :is-remove-contact-text="true"
          :partners="[
            {
              name: 'IRPC',
              image: {
                width: 245,
                height: 115,
                src: '/pages/products/commodity-plastics/irpc_logo_3.png',
              },
            },
            {
              name: 'JPP',
              image: {
                width: 274,
                height: 127,
                src: '/pages/products/commodity-plastics/pp.jpg',
              },
            },
            {
              name: 'Sabic',
              image: {
                width: 272,
                height: 145,
                src: '/pages/products/commodity-plastics/Screen-Shot-2565-05-19-at-15.08.54.png',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'pp - NAGASE THAILAND Engineering Plastics',
  meta: [
    {
      rel: 'alternate',
      hreflang: 'en',
      href: `https://group.nagase.com/th/plastics/${process.env.VITE_LANG}/products/commodity-plastics/pp-2`,
    }
  ]
})
</script>

<style scoped>
.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>